<template>
  <v-card>
    <v-card-title>
      <span class="text-h5">
        {{ $t('ITEM.EDIT') }} {{ $t('LINKS.ITEM') }}
      </span>

      <v-spacer />

      <v-btn icon @click="cancel">
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </v-card-title>

    <v-card-text>
      <v-form ref="form" v-model="valid" lazy-validation>
        <documents-link-form
          v-model="form"
          :errors="errors.getAll()"
          @update-prop="clearErrorByName($event)"
        />
      </v-form>
    </v-card-text>

    <v-card-actions>
      <v-btn outlined depressed color="grey" @click="cancel">
        {{ $t('BUTTON.CANCEL') }}
      </v-btn>
      <v-btn depressed color="error" @click="remove">
        {{ $t('BUTTON.DELETE') }}
      </v-btn>
      <confirm-dialog ref="confirm"></confirm-dialog>
      <v-spacer />

      <v-btn depressed color="primary" :disabled="!valid" @click="update">
        {{ $t('BUTTON.UPDATE') }}
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import errors from '@/modules/_global/mixins/errors';
import DocumentsLinkForm from './forms/DocumentsLinkForm.vue';
import { DocumentsLinksService } from '@/services/documents-links.service';
import { isEqual } from 'lodash';
import moment from 'moment';
import HolidayForm from '@/modules/holidays/components/forms/HolidayForm.vue';
export default {
  name: 'EditDocumentsLink',

  components: {
    DocumentsLinkForm,
    ConfirmDialog: () => import('@/modules/_global/_components/ConfirmDialog')
  },

  mixins: [errors],

  props: {
    data: {
      type: Object,
      default: () => ({})
    }
  },

  data() {
    return {
      valid: true,
      form: {}
    };
  },

  watch: {
    data: {
      deep: true,
      immediate: true,
      handler: 'valueWatchHandler'
    }
  },

  methods: {
    valueWatchHandler(formProps) {
      if (!formProps.id) {
        return;
      }
      this.getDocumentsLink(formProps.id);
    },

    getDocumentsLink(id) {
      DocumentsLinksService.getById(id)
        .then(({ data }) => {
          this.form = { ...data };
        })
        .catch(this.handleErrors);
    },

    cancel() {
      this.$emit('cancel');
    },

    update() {
      if (!this.$refs.form.validate()) {
        return;
      }

      DocumentsLinksService.update(this.form.id, this.form)
        .then(({ data }) => {
          this.$store.commit('snackbar/setSnack', {
            status: 'success',
            text: this.$t('MESSAGE.SUCCESS')
          });
          this.$emit('updated', data.data);
        })
        .catch(this.handleErrors);
    },

    remove() {
      this.$refs.confirm
        .open(this.$t('MESSAGE.REALLY_WANT_TO_REMOVE'), null, {
          cancelBtnText: this.$t('BUTTON.CANCEL'),
          agreeBtnText: this.$t('BUTTON.DELETE'),
          agreeBtnColor: 'error'
        })
        .then(confirm => {
          if (confirm) {
            DocumentsLinksService.remove(this.form.id)
              .then(({ data }) => {
                this.$emit('updated', data.data);
                this.$store.commit('snackbar/setSnack', {
                  status: 'success',
                  text: this.$t('MESSAGE.SUCCESS')
                });
              })
              .catch(this.handleErrors);
          }
        });
    }
  }
};
</script>
